var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4",class:{ 'px-4': _vm.$vuetify.breakpoint.mdAndUp }},[_c('Breadcrumbs',{class:{ 'px-5 mt-2': _vm.$vuetify.breakpoint.smAndDown },attrs:{"headline":this.$options.filters.getGradeTitle(_vm.grade),"link":[
      { text: 'Học phần', href: '../grades' },
      { text: this.$options.filters.getGradeTitle(_vm.grade), id: _vm.grade.id },
    ]}}),_c('Overview',{attrs:{"grade":_vm.grade}}),_c('ConfigTabs',{staticClass:"mt-8"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }